import { I18n } from '@calendly/i18n';
import { SimplePopup } from '@calendly/ui/components/popup';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { newOwnerSelector } from './selectors';
import { closeTransferOwnershipModal, confirmTransferOwnershipModal } from './slice';
const containerCss = "c1w5z2rr";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
export const TransferOwnershipPopup = () => {
  const dispatch = useDispatch();
  const newOwner = useSelector(newOwnerSelector);
  if (!newOwner) return null;
  const {
    name
  } = newOwner;
  const handleClose = () => {
    dispatch(closeTransferOwnershipModal());
  };
  const handleConfirm = () => {
    dispatch(confirmTransferOwnershipModal());
  };
  return <SimplePopup isOpen onClose={handleClose} onConfirm={handleConfirm} title={I18n.t('publisher.event_types.edit_hosts_modal.transfer_ownership_modal.title', {
    name
  })} cancelLabel={I18n.t('publisher.event_types.edit_hosts_modal.transfer_ownership_modal.cancel')} confirmLabel={I18n.t('publisher.event_types.edit_hosts_modal.transfer_ownership_modal.confirm')}>
      <Container>
        <BodyText>
          {I18n.t('publisher.event_types.edit_hosts_modal.transfer_ownership_modal.text1', {
          name
        })}
        </BodyText>
        <BodyText>
          {I18n.t('publisher.event_types.edit_hosts_modal.transfer_ownership_modal.text2')}
        </BodyText>
      </Container>
    </SimplePopup>;
};

require("./transfer_ownership_modal.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./transfer_ownership_modal.js");